<template>
  <naj-modal
    ref="pdfDabtAttestationModal"
    :width="1500"
    :footer="true"
    :close-button="true"
    :show-footer-close-button="true"
    @onClose="closePDFDabtAttestationModal"
  >
    <v-row>
      <v-col cols="12">
        <pdf-document-viewer
          :document="dabtDocument"
          :loading="loading"
          :has-pdf-document="true"
          :file-name="`session-dabt-${selectedSession.sessionNumber}.pdf`"
        />
        <div
          v-if="!loading && !dabtDocument"
          class="document-text preview-holder"
        >
          <h1>
            {{ local.caseFile.session.caseSessionNoData }}
          </h1>
        </div>
      </v-col>
    </v-row>
    <div v-if="selectedSession && selectedSession.userCanAttestOnDabt && showAttestationComponent">
      <v-row class="attestation-note-style">
        <v-icon class="attestation-icon-style">
          mdi-alert-circle-outline
        </v-icon>
        <v-col>
          <h1>
            {{ local.caseFile.cards.session.attestationNote }}
          </h1>
          <span class="attestation-rule-style">
            {{ attestationRule }}
          </span>
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col
        cols="12"
        md="6"
        lg="6"
      >
        <div v-if="selectedSession && selectedSession.userCanAttestOnDabt && showAttestationComponent">
          <v-form
            ref="updateSessionAttendanceFormRef"
            @submit.prevent="updateSessionAttendance"
          >
            <v-row>
              <v-col cols="12">
                <naj-input
                  :type-id="formFieldType.radioButton"
                  :label="local.caseFile.session.dabtAttestation"
                  :value.sync="attestationOption"
                  :items="attestationOptions"
                  item-value="id"
                  item-text="name"
                  validates="required"
                >
                </naj-input>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-col>
    </v-row>
    <template
      slot="actions"
      slot-scope="{ closeNajModal }"
    >
      <div v-if="selectedSession && selectedSession.userCanAttestOnDabt && showAttestationComponent">
        <naj-button
          class="cursor-pointer btn-style"
          @click="updateSessionAttendance"
        >
          {{ local.caseFile.cards.session.attest }}
        </naj-button>
      </div>
    </template>
  </naj-modal>
</template>

<script>
import PdfDocumentViewer from '../components/file-viewer/pdf-document-viewer.vue';
import { sessionStatus, attestationSigningMethod } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapCaseActions } = createNamespacedHelpers('CasesModule');
import { toHijriDate } from '@/helpers/utils';
const { mapActions: mapGlobalActions, mapState: mapGlobalState } = createNamespacedHelpers('GlobalModule');
const { mapActions } = createNamespacedHelpers('CasesModule');

export default {
  name: 'PdfDabtAttestationModal',
  components: {
    PdfDocumentViewer,
  },
  props: {
    sessionsItems: {
      type: Array,
      required: true,
    },
    modalVisibility: {
      type: Boolean,
      required: true,
    },
    selectedSessionIndexProp: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  data() {
    return {
      loading: false,
      dabtDocument: null,
      sessionStatus,
      sessions: [],
      selectedSessionIndex: this.selectedSessionIndexProp,
      attestationOption: null,

      attestationOptions: [
        {
          id: 1,
          name: this.local.common.agree,
        },
        {
          id: 2,
          name: this.local.common.notAgree,
        },
      ],
      isComponentloaded: false,
      showAttestationComponent: true,
    };
  },
  computed: {
    ...mapGlobalState(['userInfo']),
    selectedSession() {
      this.isComponentloaded = true;
      return (this.sessionsItems || [])[this.selectedSessionIndex] || {};
    },
    attestationRule() {
      if (this.selectedSession.isAgreementSession) {
        return this.local.caseFile.cards.session.agreementAttestationRule;
      }
      return this.local.caseFile.cards.session.attestationRule;
    },
  },
  methods: {
    ...mapCaseActions(['getTrustedSourceAttachment']),
    ...mapGlobalActions(['getUserInfo']),
    ...mapActions(['attestDabtByParty', 'GenerateSessionPdf']),
    toHijriDate,
    closePDFDabtAttestationModal() {
      this.attestationOption = null;
      this.showAttestationComponent = false;
      this.resetData();
      this.$emit('modalClose');
    },
    resetData() {
      this.dabtDocument = null;
      this.loading = false;
    },

    getSessionDabtDocument(index) {
      this.selectedSessionIndex = index;
      this.loading = true;
      if (this.selectedSession.sessionStatusId == sessionStatus.finished) {
        this.GenerateSessionPdf(this.selectedSession.objectKey)
          .then((res) => {
            this.dabtDocument = `data:application/pdf;base64,${res.data}`;
          }).finally(() => {
            this.loading = false;
          });
      }

      // if (this.selectedSession.spid) {
      //   this.getTrustedSourceAttachment(this.selectedSession.spid)
      //     .then((attachment) => {
      //       this.dabtDocument = `data:application/pdf;base64,${attachment}`;
      //     }).finally(() => (this.loading = false));
      // }
      // else if (this.selectedSession.sessionStatusId == sessionStatus.finished && this.selectedSession.spid == null) {
      //   this.GenerateSessionPdf(this.selectedSession.objectKey)
      //     .then((res) => {
      //       this.dabtDocument = `data:application/pdf;base64,${res.data}`;
      //     }).finally(() => {
      //       this.loading = false;
      //     });
      // }
      // else {
      //   this.resetData();
      // }
    },

    updateSessionAttendance() {
      this.$refs.updateSessionAttendanceFormRef.$validator.validateAll().then((valid) => {
        if (valid) {
          this.loading = true;
          const _sessionObjectKey = this.selectedSession.objectKey;
          const _caseObjectKey = this.selectedSession.caseInfoObjectKey;
          const _attestationOption = this.attestationOption;
          this.attestDabtByParty({
            sessionObjectKey: _sessionObjectKey,
            caseObjectKey: _caseObjectKey,
            attestationOption: _attestationOption,
          })
            .then(() => {
              this.closePDFDabtAttestationModal();
              this.toaster.success(this.local.caseFile.cards.session.attestationSuccessfully);
              this.$emit('reloadTodaySessions', this.selectedSession.objectKey, this.selectedSession.isVideoConference);
              this.$set(this.sessionsItems[this.selectedSessionIndex], 'userHasAttestedOnDabt', true);
              const attendanceUserIndex = this.selectedSession.sessionAttendences.findIndex(
                element => this.userInfo.socialId == element.socialId
              );
              if (attendanceUserIndex > -1) {
                this.$set(this.selectedSession.sessionAttendences[attendanceUserIndex], 'signingDate', new Date());
                this.$set(
                  this.selectedSession.sessionAttendences[attendanceUserIndex],
                  'signingMethod',
                  attestationSigningMethod.fromPortal
                );
                this.$emit('reloadSessions', this.selectedSession.objectKey, this.selectedSession.isVideoConference);
                this.showAttestationComponent = false;
              }
            })
            .finally(() => {
              this.loading = false;
            });
        } else {
          this.toaster.error(this.local.caseFile.cards.session.selectToAttest);
        }
      });
    },
  },
  watch: {
    modalVisibility(newValue) {
      this.dabtDocument = '';
      if (newValue) {
        this.showAttestationComponent = true;
        this.$refs.pdfDabtAttestationModal.show();
        this.getSessionDabtDocument(this.selectedSessionIndexProp);
      } else {
        this.$refs.pdfDabtAttestationModal.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.preview-holder {
  display: block !important;
  height: 600px;
  width: 100%;
}

.document-text {
  font-size: 18px;
  line-height: 1.8;
  color: #6d6d6d;
}

.session-entry {
  border: 2px solid #a2a2a2;
  border-radius: 5px;
  cursor: pointer;

  &.outlined {
    border: 4px solid #1fb9b8;
  }

  .text-info-value {
    font-size: 14px;
    font-weight: bold;
  }
}
.pdf-container {
  position: relative;
  overflow: hidden;
  width: 90%;
}
::v-deep .v-input--radio-group {
  .options-list {
    display: inline-grid !important;
  }

  .radio-button-option {
    background: none !important;
    border: none !important;
  }
}
.btn-style {
  background: none !important;
  color: forestgreen !important;
}
.attestation-note-style {
  background-color: #cde9f6;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-right: 5px;
  border-style: solid;
  border-right-color: #416695;
  color: #416695;
  padding: 20px;
}
.attestation-rule-style {
  font-size: 15px;
}
.attestation-icon-style {
  font-size: 60px;
  color: #416695;
  -webkit-text-stroke: 2px #cde9f6;
}
</style>